import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-query';
import { incentiveData } from '../globalApi/Api';
import { useNavigate } from 'react-router-dom';
import PopupModel from '../popupmodel/PopupModel';
import axios from 'axios';
import Images from '../../assests/Images';
import DatePicker from 'react-datepicker';
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import moment from 'moment';

import * as XLSX from "xlsx";

const IncentiveView = () => {
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        getValues,
        reset,
    } = useForm();


    const [selectedRows, setSelectedRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [incentiveList, setIncentiveList] = useState();
    const navigate = useNavigate();
    const [isIncentiveOpen, setIsIncentiveOpen] = useState(false);


    const fromDate = watch("fromDate");
    const toDate = watch("toDate");

    // GET API START
    const { data, isLoading, isError, refetch } = useQuery(
        "incentiveData",
        incentiveData,
        {
            refetchOnWindowFocus: false,
        }
    );
    let details = (data && data?.data) || [];
    // GET API END


    const filteredDetails =
        details &&
        details
            ?.filter((item) => {
                const lowerSearch = searchTerm?.toLowerCase();

                const nameMatch = item?.executiveName
                    ?.toLowerCase()
                    .startsWith(lowerSearch);
                const itemDateStr = item?.incentiveDate
                    ? moment(item?.incentiveDate).format("YYYY-MM-DD")
                    : null;

                const fromDateStr = fromDate
                    ? moment(fromDate).format("YYYY-MM-DD")
                    : null;
                const toDateStr = toDate
                    ? moment(toDate).format("YYYY-MM-DD")
                    : null;

                const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
                const toDateMatch = !toDateStr || itemDateStr <= toDateStr;

                const dateMatch = fromDateMatch && toDateMatch;

                return (
                    (nameMatch) &&
                    dateMatch
                );
            })
            ?.sort((a, b) =>
                new Date(a.incentiveDate) - new Date(b.incentiveDate)
            );



    // DELETE API
    // Delete a user by ID
    const deleteUser = async (id) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_HOST}/incentives/${id}`
            );
            return response.data;
        } catch (error) {
            console.error(`Error deleting user with ID ${id}:`, error);
            throw error;
        }
    };

    const deleteUsers = async (ids) => {
        try {
            const results = await Promise.all(
                ids?.map(async (id) => {
                    return await deleteUser(id);
                })
            );
            return results; // Return all results after deletion
        } catch (error) {
            console.error("Error deleting multiple users:", error.message);
            throw new Error("Failed to delete multiple users");
        }
    };
    // Mutation to delete users
    const { mutate, isLoading: deleteLoading } = useMutation({
        mutationFn: deleteUsers,
        onSuccess: () => {

            setSelectedRows([]);
            refetch();
        },
        onError: (error) => {
            console.error("Error deleting rows:", error);
            alert("Error deleting rows");
        },
    });

    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelectedRows) => {
            const isSelected = prevSelectedRows?.includes(id);
            if (isSelected) {
                return prevSelectedRows?.filter((rowId) => rowId !== id);
            } else {
                return [...prevSelectedRows, id];
            }
        });
    };
    // Handle delete button click
    const handleDelete = () => {
        if (selectedRows?.length === 0) {
            alert("No rows selected");
            return;
        }
        mutate(selectedRows);
    };

    // DELETE API END


    // Download Excel
    const downloadExcel = () => {
        // Define headers
        const headers = [
            "S.NO",
            "EXECUTIVE NAME",
            "INCENTIVE DATE",
            "INCENTIVE AMOUNT"
        ];

        // Map data to match the headers order
        const formattedData =
            filteredDetails &&
            filteredDetails?.map((item, index) => ({
                "S.NO": index + 1,
                "EXECUTIVE NAME": item?.executiveName || "",
                "INCENTIVE DATE": item?.incentiveDate || "",
                "INCENTIVE AMOUNT": item?.totalIncentive || "",
            }));

        // Create a new workbook and a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, "Incentive.xlsx");
    };





    return (
        <>

            <div className="view_form_block">
                <div className="view_form_sub_block">
                    <div className="row my-3">
                        <div className="row my-3">
                            <div className="col-lg-12 d-flex justify-content-center align-items-center gap-3">
                                <Controller
                                    control={control}
                                    name="fromDate"
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            selected={field.value}
                                            onChange={field.onChange}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="Select From Date"
                                            maxDate={new Date()}
                                            className="filter_date_picker"
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="toDate"
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            selected={field.value}
                                            onChange={field.onChange}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="Select To Date"
                                            minDate={fromDate}
                                            maxDate={new Date()}
                                            className="filter_date_picker"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row px-3">
                        {/* Search Input */}
                        <div className="col-12 col-md-4 mb-3 mb-md-0">
                            <input
                                type="search"
                                className="view_table_search"
                                placeholder="Search by name"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-lg d-flex flex-wrap justify-content-end gap-2">


                            {/* Download Button */}
                            <div
                                className="download_btn_block_order d-flex align-items-center"
                                onClick={downloadExcel}

                            >
                                <div className="download_image_block">
                                    <img
                                        src={Images?.downloadIcon}
                                        className="image_icon"
                                        alt="download-icon"
                                    />
                                </div>
                                <button className="download_btn">DOWNLOAD</button>
                            </div>

                            {/* Delete Button */}
                            {selectedRows?.length > 0 && (
                                <div
                                    className="download_btn_block_purchase d-flex align-items-center"
                                    onClick={() => {
                                        handleDelete();
                                    }}
                                >
                                    <div className="download_image_block">
                                        <img
                                            src={Images?.deleteIcon}
                                            className="image_icon"
                                            alt="delete-icon"
                                        />
                                    </div>
                                    <button className="download_btn">

                                        {
                                            deleteLoading ? (<>
                                                <i class="fa fa-spinner fa-spin"></i>
                                            </>) : (<>
                                                DELETE
                                            </>)
                                        }
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="view-table-heading">SELECT</th>
                                            <th className="view-table-heading">EXECUTIVE ID</th>
                                            <th className="view-table-heading">EXECUTIVE NAME</th>
                                            <th className="view-table-heading">INCENTIVE DATE</th>
                                            <th className="view-table-heading">INCENTIVE AMOUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <>
                                                <h5 className="my-3">L O A D I N G . . .</h5>
                                            </>
                                        ) : filteredDetails?.length > 0 ? (
                                            <>
                                                {filteredDetails?.map((data, i) => {
                                                    return (
                                                        <>
                                                            <tr
                                                                key={i}
                                                                onClick={() => {
                                                                    // navigate("/newExecutive", { state: data });
                                                                    setIsIncentiveOpen(true);
                                                                    setIncentiveList(data);

                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <td
                                                                    className="view-table-data"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                >

                                                                    <input
                                                                        type="checkbox"
                                                                        style={{
                                                                            accentColor: "blue",
                                                                            width: "18px",
                                                                            height: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        checked={selectedRows?.includes(data?.id)}
                                                                        onChange={() =>
                                                                            handleCheckboxChange(data?.id)
                                                                        }
                                                                    />


                                                                </td>
                                                                <td className="view-table-data">
                                                                    {i + 1 || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.executiveName || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.incentiveDate || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.totalIncentive || "-"}
                                                                </td>

                                                            </tr>

                                                        </>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <h6>No Record Founds</h6>
                                            </>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PopupModel
                isOpen={isIncentiveOpen}
                closePopup={() => {
                    setIsIncentiveOpen(false);
                }}
                type="Incentive"
                incentiveDetails={incentiveList}

            />
        </>
    )
}

export default IncentiveView